import React from 'react'
import { css } from '@emotion/core'

const body1 = css`
  font-size: 16px;
  line-height: 28px;
  padding-top: 3px;
  padding-bottom: 13px;
  letter-spacing: 0.005em;
  margin: 0;
  word-break: break-word;
  color: var(--gray100);
  color: var(--special-type-color, var(--gray100));
`

const body2 = css`
  box-sizing: border-box;
  font-size: 14px;
  letter-spacing: 0.035px;
  line-height: 24px;
  margin: 0;
  word-break: break-word;
  padding-bottom: 14px;
  padding-top: 2px;
`

export const headerCss = css`
  font-size: 34px;
`

export const subheaderCss = css`
  font-family: var(--font-families-body);
  font-weight: 400;
  font-size: var(--text-size-c);
`

const centered_css = css`
  text-align: center;
`

export function Subheading({ children, ...props }) {
  return (
    <span css={subheaderCss} {...props}>
      {children}
    </span>
  )
}

export function Body1({ centered, children, ...props }) {
  return (
    <p css={[body1, centered ? centered_css : '']} {...props}>
      {children}
    </p>
  )
}

export function Body2({ children, ...props }) {
  return (
    <p css={body2} {...props}>
      {children}
    </p>
  )
}
